import { render, staticRenderFns } from "./addword.vue?vue&type=template&id=2a582432&scoped=true&"
import script from "./addword.vue?vue&type=script&lang=js&"
export * from "./addword.vue?vue&type=script&lang=js&"
import style0 from "./addword.vue?vue&type=style&index=0&id=2a582432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a582432",
  null
  
)

export default component.exports